import type { PolicySchema } from '../policies/list';

export type OffsetPagination = {
  total: number;
  limit: number;
  offset: number;
};

export type CursorPagination = {
  limit: number;
  nextCursor: string | null;
};

export type Pagination = OffsetPagination | CursorPagination;

export function isOffsetPagination(pagination: Pagination): pagination is OffsetPagination {
  return 'offset' in pagination && 'total' in pagination;
}

export function isCursorPagination(pagination: Pagination): pagination is CursorPagination {
  return 'nextCursor' in pagination;
}

export type ConfirmationResponse = {
  success: boolean;
};

export interface ApiPaginatedResponse<T> {
  data: T[];
  policies?: PolicySchema[];
  pagination?: Pagination;
}

export interface ApiResponse<T> {
  data: T;
  policies?: PolicySchema[];
}

export enum PostStatus {
  Draft = 'draft',
  InProgress = 'in_progress',
  PendingApproval = 'pending_approval',
  Approved = 'approved',
  Scheduled = 'scheduled',
  Published = 'published',
  Archived = 'archived',
}

export interface FileUploadProps {
  fileName: string;
  contentType: string;
  fileSize: number;
}

export interface UploadUrlParams {
  url: string;
  fields: Record<string, string>;
}
